import { CLAIMS_SOURCE } from "./claims-source";
import {
  RECYCLE_DESTINATION,
  WITHDRAWALS_DESTINATION,
} from "./jump-only-destinations";
import type {
  HomeRecordType,
  JumpToDestination,
  RecordHomeSource,
} from "./record-home-source";
import { RETURNS_SOURCE } from "./returns-source";
import { WARRANTIES_SOURCE } from "./warranties-source";

/** The home page each type's index shows; a type without one keeps its table. */
export const HOME_PAGES: Partial<
  Record<HomeRecordType, readonly RecordHomeSource[]>
> = { returns: [RETURNS_SOURCE, CLAIMS_SOURCE, WARRANTIES_SOURCE] };

/** Types a home links to from Jump to without searching or counting them. */
export const HOME_JUMP_ONLY: Partial<
  Record<HomeRecordType, readonly JumpToDestination[]>
> = { returns: [RECYCLE_DESTINATION, WITHDRAWALS_DESTINATION] };
